import { ShowIf, isDateInFuture } from '@apply/ui';
import { PropertyDevelopment } from './components/PropertyDevelopment';
import { YearBuilt } from '../../../components/YearBuilt';
import { usePropertyDevelopmentType } from '../../../../../queries/PropertyFields/BridgeFields';
import { LoanSubType, PropertyDevelopmentType } from '@apply/constants';
import { useBorrowerLoanSubType } from '../../../../../queries/BorrowerFields/CoreFields';
import { usePropertyDevelopmentTypeSync } from '../../queries/usePropertyDevelopmentTypeSync';
import { OwnedThroughoutDevelopment } from './components/OwnedThroughDevelopment';
import { DateOfAcquisition } from '../../../components/DateOfAcquisition';
import { AcquisitionFinancing } from '../../../components/AcqusitionFinancing';
import { PropertyDevelopmentOther } from './components/PropertyDevelopmentOther';
import { usePropertyAcquisitionDate } from '../../../../../queries/PropertyFields';
import { ToggleButtonLabelSize } from '@apply/components';
import { DateTimeBoxLabelSize } from '@apply/components/src/components/controls/DateBox/DateTimeBox';

interface PropertyDevelopmentInfoProps {
    propertyGuid: string;
    isReview?: boolean;
}

export const PropertyDevelopmentInfo: React.FC<PropertyDevelopmentInfoProps> = ({ propertyGuid, isReview = false }) => {
    const [propertyDevelopmentType] = usePropertyDevelopmentType(propertyGuid);
    const [acquisitionDate] = usePropertyAcquisitionDate(propertyGuid);
    const [loanSubType] = useBorrowerLoanSubType();

    usePropertyDevelopmentTypeSync(propertyGuid, isReview);

    // An Acquisition Bridge is always a New Acquisition, so the question is set for the borrower
    // rather than asked. Applications saved before Bridge gained sub-types still get the dropdown.
    const isAcquisitionBridge = loanSubType === LoanSubType.AcquisitionBridge;

    const isConstructionOrRenovation =
        propertyDevelopmentType !== undefined &&
        [
            PropertyDevelopmentType.NewConstruction,
            PropertyDevelopmentType.Renovation,
            PropertyDevelopmentType.RenovationAndExpansion,
        ].includes(propertyDevelopmentType);

    return (
        <>
            <ShowIf showIf={!isAcquisitionBridge}>
                <PropertyDevelopment
                    propertyGuid={propertyGuid}
                    required={true}
                    isReview={isReview}
                />
            </ShowIf>
            <ShowIf showIf={isConstructionOrRenovation}>
                <YearBuilt
                    propertyGuid={propertyGuid}
                    required={true}
                    isReview={isReview}
                />
                <OwnedThroughoutDevelopment
                    propertyGuid={propertyGuid}
                    required={true}
                    isReview={isReview}
                />
            </ShowIf>
            <ShowIf showIf={propertyDevelopmentType == PropertyDevelopmentType.NewAcquisition}>
                <DateOfAcquisition
                    propertyGuid={propertyGuid}
                    required={true}
                    isReview={isReview}
                    labelSize={DateTimeBoxLabelSize.Small}
                />
                <ShowIf showIf={isDateInFuture(acquisitionDate ?? null) === true}>
                    <AcquisitionFinancing
                        propertyGuid={propertyGuid}
                        required={true}
                        isReview={isReview}
                        labelSize={ToggleButtonLabelSize.Medium}
                    />
                </ShowIf>
            </ShowIf>
            <ShowIf showIf={propertyDevelopmentType == PropertyDevelopmentType.Other}>
                <PropertyDevelopmentOther
                    propertyGuid={propertyGuid}
                    required={true}
                    isReview={isReview}
                />
            </ShowIf>
        </>
    );
};
